import React from 'react';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Input,
  Box,
  Text,
  useColorModeValue,
  FormControl,
  FormErrorMessage,
  Icon,
} from '@chakra-ui/react';
import { IoCloseCircleOutline } from 'react-icons/io5';

const GroupScheduleTable = ({ slots, schedule, onScheduleChange, validated }) => {
  const brandStars = useColorModeValue('red.500', 'red.400');
  const errorTextColor = useColorModeValue('red.500', 'red.300');

  const handleTimeChange = (key, field, value) => {
    const updated = {
      ...schedule,
      [key]: {
        ...schedule[key],
        [field]: value,
      },
    };
    onScheduleChange(updated);
  };

  const isFieldMissing = (slotKey, field, isRequired) => {
    const { start_time, end_time } = schedule[slotKey] || {};

    if (validated && isRequired) {
      return !schedule[slotKey]?.[field];
    }

    if (validated && !isRequired) {
      const hasAny = !!start_time || !!end_time;
      const missingField = !schedule[slotKey]?.[field];
      return hasAny && missingField;
    }

    return false;
  };

  const slotHasRangeError = (slotKey, isRequired) => {
    const { start_time, end_time } = schedule[slotKey] || {};

    if (isRequired && start_time && end_time && start_time >= end_time) {
      return true;
    }

    if (!isRequired && start_time && end_time && start_time >= end_time) {
      return true;
    }

    return false;
  };

  const handleClearSlot = (key) => {
    const updated = {
      ...schedule,
      [key]: {
        ...schedule[key],
        start_time: '',
        end_time: '',
      },
    };
    onScheduleChange(updated);
  };

  return (
    <Box overflowX="auto">
      <Table variant="simple" className='time-slot-table'>
        <Thead>
          <Tr>
            <Th colSpan="3" textAlign="center">
              <Text fontWeight="900" color="black">Schedule</Text>
            </Th>
          </Tr>
          <Tr>
            <Th>Slot</Th>
            <Th>Start Time</Th>
            <Th>End Time</Th>
          </Tr>
        </Thead>
        <Tbody>
          {slots.map(({ key, label, required }) => {
            const hasTime = !!schedule[key]?.start_time || !!schedule[key]?.end_time;

            return (
              <React.Fragment key={key}>
                <Tr>
                  <Td>
                    {label}
                    {required && <Text as="span" color={brandStars}> *</Text>}
                  </Td>
                  <Td>
                    <FormControl isInvalid={isFieldMissing(key, 'start_time', required)}>
                      <Input
                        type="time"
                        value={schedule[key]?.start_time || ''}
                        onChange={(e) =>
                          handleTimeChange(key, 'start_time', e.target.value)
                        }
                      />
                    </FormControl>
                  </Td>
                  <Td>
                    <FormControl isInvalid={isFieldMissing(key, 'end_time', required)}>
                      <Input
                        type="time"
                        value={schedule[key]?.end_time || ''}
                        onChange={(e) =>
                          handleTimeChange(key, 'end_time', e.target.value)
                        }
                      />
                    </FormControl>
                  </Td>
                  <Td>
                    {
                      hasTime && (<Icon
                        as={IoCloseCircleOutline}
                        h={6}
                        w={6}
                        onClick={() => handleClearSlot(key)}
                        cursor="pointer"
                        title='Clear Slot'
                        color='red'
                      />
                      )}
                  </Td>
                </Tr>
                {validated && (
                  (isFieldMissing(key, 'start_time', required) || isFieldMissing(key, 'end_time', required)) && (
                    <Tr>
                      <Td colSpan="4" pt={0} pb={2}>
                        <Text color={errorTextColor} fontSize="sm">
                          Start time and end time are required for this slot.
                        </Text>
                      </Td>
                    </Tr>
                  )
                )}
                {validated && slotHasRangeError(key, required) && (
                  <Tr>
                    <Td colSpan="3" pt={0} pb={0}>
                      <Text color={errorTextColor} fontSize="sm">
                        Start time must be earlier than end time for this slot.
                      </Text>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            )
          })}
        </Tbody>
      </Table>
    </Box>
  );
};

export default GroupScheduleTable;
